import React, { useState, useEffect, useCallback } from "react";
import Layout from "../components/layout";
import { useDispatch } from "react-redux";
import axios from "axios";
import { showLoading, hideLoading } from "../redux/alertsSlice";
import {
  Table,
  Row,
  Col,
  Input,
  Button,
  Modal,
  Dropdown,
  Space,
} from "antd";
import moment from "moment";

function Appointment() {
  const [appointments, setAppointments] = useState([]);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useDispatch();

  const getAppointmentData = useCallback(async () => {
    try {
      dispatch(showLoading());
      const response = await axios.get("/api/user/get-appointments-by-user-id", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      dispatch(hideLoading());
      if (response.data.success) {
        setAppointments(response.data.data);
      }
    } catch (error) {
      dispatch(hideLoading());
      console.error("Error fetching appointments:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    getAppointmentData();
  }, [getAppointmentData]);

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const clearFilters = () => setFilteredInfo({});
  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  const showAppointmentModal = (appointment) => {
    setSelectedAppointment(appointment);
    setIsModalVisible(true);
  };

  const handleCancel = () => setIsModalVisible(false);

  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return "approved-status";
      case "rejected":
        return "rejected-status";
      case "follow-up":
        return "followup-status";
      case "completed":
        return "completed-status";
      default:
        return "pending-status";
    }
  };

  const filteredAppointments = appointments.filter((appointment) =>
    appointment.doctorInfo.service
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );


    const printContent = () => {
    const printWindow = window.open("", "_blank");
    const content = document.getElementById("printable-area").innerHTML;
    printWindow.document.write(`
      <html>
      <head>
        <title>Appointment Summary</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          h2 { text-align: center; border-bottom: 2px solid #333; margin-bottom: 20px; }
          table { width: 100%; border-collapse: collapse; }
          td { padding: 10px; border: 1px solid #ddd; }
          .clinic-days span { background: #f3f3f3; padding: 5px 10px; margin: 5px; border-radius: 4px; display: inline-block; }
          @media print { .print-button { display: none; } }
        </style>
      </head>
      <body onload="window.print(); window.close();">
        ${content}
      </body>
      </html>
    `);
    printWindow.document.close();
  };

  const columns = [
    {
      title: "Doctor Name",
      dataIndex: "doctorName",
      key: "doctorName",
      render: (text, record) =>
        `${record.doctorInfo.firstName} ${record.doctorInfo.lastName}`,
      sorter: (a, b) =>
        a.doctorInfo.firstName.localeCompare(b.doctorInfo.firstName),
      sortOrder:
        sortedInfo.columnKey === "doctorName" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "Service",
      dataIndex: "service",
      key: "service",
      render: (text, record) => record.doctorInfo.service,
      filters: [
        ...new Set(appointments.map((a) => a.doctorInfo.service)),
      ].map((s) => ({ text: s, value: s })),
      filteredValue: filteredInfo.service || null,
      onFilter: (value, record) => record.doctorInfo.service === value,
      sorter: (a, b) =>
        a.doctorInfo.service.localeCompare(b.doctorInfo.service),
      sortOrder:
        sortedInfo.columnKey === "service" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      responsive: ['md'],
      render: (text, record) => record.doctorInfo.location,
      sorter: (a, b) =>
        a.doctorInfo.location.localeCompare(b.doctorInfo.location),
      sortOrder:
        sortedInfo.columnKey === "location" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "Fee",
      dataIndex: "fee",
      key: "fee",
      render: (text, record) => `₦${record.doctorInfo.feePerConsultation}`,
      sorter: (a, b) =>
        a.doctorInfo.feePerConsultation - b.doctorInfo.feePerConsultation,
      sortOrder: sortedInfo.columnKey === "fee" ? sortedInfo.order : null,
      ellipsis: true,
    },
       {
  title: "Scheduled Date",
  key: "schedule_date",
  render: (_, r) =>
    (r.status === "approved" || r.status === "follow-up") && r.schedule_date
      ? moment(r.schedule_date).format("DD-MM-YYYY")
      : "Not set",
  sorter: (a, b) =>
    moment(a.schedule_date || 0).unix() - moment(b.schedule_date || 0).unix(),
  sortOrder: sortedInfo.columnKey === "schedule_date" ? sortedInfo.order : null,
},

{
  title: "Appointment Time",
  key: "appointmentTime",
  render: (_, r) => {
    const time = r.doctorInfo?.appointmentTime;
    const statusOk = r.status === "approved" || r.status === "follow-up";

    if (statusOk && Array.isArray(time) && time.length === 2) {
      return `${time[0]} - ${time[1]}`;
    } else {
      return "Not set";
    }
  },
  sorter: (a, b) => {
    const aTime = a.doctorInfo?.appointmentTime?.[0] || "00:00";
    const bTime = b.doctorInfo?.appointmentTime?.[0] || "00:00";
    return moment(aTime, "HH:mm").unix() - moment(bTime, "HH:mm").unix();
  },
  sortOrder: sortedInfo.columnKey === "appointmentTime" ? sortedInfo.order : null,
},




          {
               title: "Followup Date",
               key: "followUpDate",
               render: (_, r) =>
                  r.status === "follow-up" && r.followUpDate
                   ? moment(r.followUpDate).format("DD-MM-YYYY")
                   : "No followup date",
               sorter: (a, b) =>
                 moment(a.schedule_date || 0).unix() - moment(b.followUpDate || 0).unix(),
               sortOrder: sortedInfo.columnKey === "followUpDate" ? sortedInfo.order : null,
             },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      filters: [
        { text: "Approved", value: "approved" },
        { text: "Pending", value: "pending" },
        { text: "Rejected", value: "rejected" },
        { text: "Follow-Up", value: "follow-up" },
        { text: "Completed", value: "completed" },
      ],
      filteredValue: filteredInfo.status || null,
      onFilter: (value, record) => record.status === value,
      render: (text, record) => (
        <span className={`status-indicator ${getStatusColor(record.status)}`}>
          {record.status.charAt(0).toUpperCase() + record.status.slice(1)}
        </span>
      ),
    },
    {
     
  title: "Actions",
  key: "actions",
  render: (_, record) => {
    const status = record.status?.toLowerCase();
    const isApproved = status === "approved" || status === "follow-up";

    const startISO = record.date;
    const endISO = moment(record.date).add(30, "minutes");

    const common = {
      title: `Appointment – ${record.doctorInfo.service}`,
      details: `Doctor: Dr. ${record.doctorInfo.firstName} ${record.doctorInfo.lastName}\nStatus: ${record.status}`,
      location: record.doctorInfo.location,
      startISO,
      endISO,
    };




const generateICSFile = (record) => {
  if (!record || typeof record !== "object" || !record.doctorInfo) {
    return "";
  }

  const appointmentTime = record.doctorInfo.appointmentTime || [];
  const startTime = appointmentTime[0];
  const endTime = appointmentTime[1];

  // Format: record.schedule_date is ISO string (e.g., "2025-07-30T23:00:00.000Z")
  const scheduleDate = moment(record.schedule_date); // parse from ISO

  const startDateTime = moment(`${scheduleDate.format("YYYY-MM-DD")} ${startTime}`, "YYYY-MM-DD HH:mm")
    .utc()
    .format("YYYYMMDDTHHmmss[Z]");

  const endDateTime = moment(`${scheduleDate.format("YYYY-MM-DD")} ${endTime}`, "YYYY-MM-DD HH:mm")
    .utc()
    .format("YYYYMMDDTHHmmss[Z]");

  const now = moment().utc().format("YYYYMMDDTHHmmss[Z]");

  return `
BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//YourApp//EN
CALSCALE:GREGORIAN
BEGIN:VEVENT
UID:${record._id || "no-id"}@lilyonlinebooking.com
DTSTAMP:${now}
DTSTART:${startDateTime}
DTEND:${endDateTime}
SUMMARY:Appointment with Dr. ${record.doctorInfo.firstName || ""} ${record.doctorInfo.lastName || ""}
DESCRIPTION:Service: ${record.doctorInfo.service || "N/A"}\\nStatus: ${record.status || "N/A"}
LOCATION:${record.doctorInfo.location || "Not specified"}
END:VEVENT
END:VCALENDAR`.trim().replace(/\n/g, "\r\n");
};




       const downloadICS = () => {
  const ics = generateICSFile(record);   // <-- pass record
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `appointment-${record._id}.ics`;
  a.click();
  URL.revokeObjectURL(url);
};

        const buildGoogleUrl = () => {
          const fmt = (d) => moment(d).utc().format("DDMMYYYYTHHmmss[Z]");
          return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
            common.title
          )}&details=${encodeURIComponent(
            common.details
          )}&location=${encodeURIComponent(
            common.location
          )}&dates=${fmt(startISO)}/${fmt(endISO)}`;
        };
        const buildOutlookUrl = () =>
          `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(
            common.title
          )}&body=${encodeURIComponent(
            common.details
          )}&location=${encodeURIComponent(
            common.location
          )}&startdt=${encodeURIComponent(
            startISO
          )}&enddt=${encodeURIComponent(endISO)}`;
const calendarMenu = {
  items: [
    { key: "google",  label: "Add to Google Calendar" },
    { key: "outlook", label: "Add to Outlook / Microsoft 365" },
    { key: "ics",     label: "Download .ics (other apps)" },
  ],
  onClick: ({ key }) => {
    if (key === "google") window.open(buildGoogleUrl(), "_blank");
    if (key === "outlook") window.open(buildOutlookUrl(), "_blank");
    if (key === "ics") downloadICS();
  },
};


        return (
          <div style={{ display: "flex",  gap: "8px"}}>
            <Button onClick={() => showAppointmentModal(record)}>View & Print</Button>
            {isApproved && (
<Dropdown trigger={["click"]} menu={calendarMenu}>
  <Button type="primary">Export to Calendar ↧</Button>
</Dropdown>


            )}
          </div>
        );
      },
    },
  ];

  return (
    <Layout>
   
      <Row gutter={[16, 16]} className="mb-2">
        <Col span={8}  xs={24} sm={24} md={8}>
          <Input placeholder="Search by Service..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
        </Col>
        <Col span={16} xs={24} sm={24} md={16}>
          <Space>
            <Button onClick={clearFilters}>Clear Filters</Button>
            <Button onClick={clearAll}>Clear All</Button>
          </Space>
        </Col>
      </Row>
      <Table
        columns={columns}
        dataSource={filteredAppointments}
        rowKey="_id"
        onChange={handleChange}
        scroll={{ x: "max-content" }} // enables horizontal scroll on smaller screens
      />

      <Modal
        open={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button key="print" onClick={printContent}>Print</Button>,
          <Button key="close" onClick={handleCancel}>Close</Button>,
        ]}
      >
        {selectedAppointment && (
          <div id="printable-area">
            <h2>Appointment Details</h2>
            <table className="appointment-details">
              <tbody>
                <tr>
                  <td><strong>Doctor:</strong></td>
                  <td>{selectedAppointment.doctorInfo.firstName} {selectedAppointment.doctorInfo.lastName}</td>
                </tr>
                <tr>
                  <td><strong>Service:</strong></td>
                  <td>{selectedAppointment.doctorInfo.service}</td>
                </tr>
                <tr>
                  <td><strong>Location:</strong></td>
                  <td>{selectedAppointment.doctorInfo.location}</td>
                </tr>
                <tr>
                  <td><strong>Date:</strong></td>
                  <td>{moment(selectedAppointment.date).format("MMMM Do YYYY, h:mm a")}</td>
                </tr>
                <tr>
                  <td><strong>Status:</strong></td>
                  <td>{selectedAppointment.status}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </Modal>
    </Layout>
  );
}

export default Appointment;
